module.exports = __webpack_public_path__ + "654f147059d335de231b186fd23886dd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-24.png
// module id = 2197
// module chunks = 0